import { ItiString } from "@/iti-core-react/utils/iti-string";
import { SortType } from "@/shared/enums/catalogue-search-filter-type";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SortDirection } from "@/shared/dtos/page-types.ts";
import { ICatalogueSearchFilter } from "@/shared/dtos/catalogue-search-filter-dto.ts";
import { DatasetImportStatusEnum } from "@/shared/enums/Governance/dataset-import-status-enum.ts";

interface CatalogueSearchFilterState {
	catalogueSearchFilter: ICatalogueSearchFilter;
}

const DEFAULT_FILTER: ICatalogueSearchFilter = {
	limit: 12,
	offset: 0,
	categories: [],
	owners: [],
	accessRights: [],
	terms: [],
	importStatus: [DatasetImportStatusEnum.OK],
	text: ItiString.Empty,
	sortBy: SortType.Name,
	sort: SortDirection.ASC,
};

function loadPersistedFilter(): ICatalogueSearchFilter {
	try {
		const saved = localStorage.getItem("CatalogueSearchFilter");
		return saved ? { ...DEFAULT_FILTER, ...JSON.parse(saved) } : DEFAULT_FILTER;
	} catch {
		return DEFAULT_FILTER;
	}
}

const initialState: CatalogueSearchFilterState = {
	catalogueSearchFilter: loadPersistedFilter(),
};

const searchFilterSlice = createSlice({
	name: "searchFilter",
	initialState,
	reducers: {
		setSearchFilter(
			state,
			action: PayloadAction<Partial<ICatalogueSearchFilter>>,
		) {
			state.catalogueSearchFilter = {
				...state.catalogueSearchFilter,
				...action.payload,
			};
		},
		resetSearchFilter(state) {
			state.catalogueSearchFilter = { ...DEFAULT_FILTER };
		},
		updateAccessRightValue(state, action: PayloadAction<string[]>) {
			state.catalogueSearchFilter.accessRights = action.payload;
		},
	},
});

export default searchFilterSlice;
